import React, { useState } from "react";
import { Container, Navbar, Nav, Form, Image, Col } from "react-bootstrap";
import logo from "../../../../images/login/white-logo.png";
import email from "../../../../images/login/email-login.png";
import password from "../../../../images/login/password-login.png";
import line from "../../../../images/login/or-pic.png";
import apple from "../../../../images/login/apple.png";
import google from "../../../../images/login/google.png";
import close from "../../../../images/customer/hide.svg";
import open from "../../../../images/customer/open.svg";
import facebook from "../../../../images/login/facebook.png";
import Button from "../../../../common/Button/Button";
import { useNavigate } from "react-router-dom";

const Login: React.FC = () => {
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const navigate = useNavigate();
  return (
    <div>
      <section className="owner_login">
        <Col lg={6} className="left-side customer_left position-relative">
          <div className="left_content">
            <div className="owner_logo py-3">
              <a href="/">
                <Image src={logo} alt="img" />
              </a>
            </div>

            <div className="welcome_text login-paragraph">
              <p className="login-p-tag">
                <span>Welcome,</span> We are glad
                <br />
                to see you again!
              </p>
            </div>
          </div>
        </Col>

        <Col lg={6} className="right-side customer_right position-relative">
          <Navbar className="bg-none" expand="lg">
            <Container fluid className="navbar-collapse admin_toggle ">
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                  <Nav.Link className="header_nav_link" href="/">Home</Nav.Link>
                  <Nav.Link className="header_nav_link" href="/">About Us</Nav.Link>
                  <Nav.Link className="header_nav_link" href="/">Contact Us</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>

          <div className="login_form">
            <h3>Login to your account</h3>
            <Form.Group className="my-4 owner_input position-relative">
              <Form.Control type="text" placeholder="Email address" />
              <span>
                <Image src={email} alt="img" />
              </span>
            </Form.Group>
            <Form.Group className="my-4 owner_input position-relative">
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                placeholder="Password" />
              <span>
                <Image src={password} alt="img" />
              </span>
              <Image
                src={showPassword ? open : close}
                className='show-password'
                onClick={() => setShowPassword(!showPassword)}
                alt="password"
              />
            </Form.Group>
            <Form.Group className="my-3 d-flex justify-content-between align-items-center">
              <Form.Check type="checkbox" label="Keep me logged in" />
              <a className="forgot_login" href="/forgot-password">
                Forgot Password
              </a>
            </Form.Group>
            <div className="owner_btn">
              <Button
                type="submit"
                className="w-100 btn btn-primary"
                onClick={() => navigate("/dashboard")}
              >
                Login
              </Button>
            </div>
            <div className="agent_or py-3">
              <Image src={line} alt="img" />
              <div className="agent_login_option">
                <a href="/">
                  <Image src={apple} alt="img" />
                </a>
                <a href="/">
                  <Image src={facebook} alt="img" />
                </a>
                <a href="/">
                  <Image src={google} alt="img" />
                </a>
              </div>
            </div>
          </div>
          <p className="register_login">
            Don’t have an account? <a href="/signup">Register</a>
          </p>
        </Col>
      </section>
    </div>
  );
};

export default Login;
